/* eslint-disable @typescript-eslint/naming-convention */

/** Sampling rates the waveform chart can display. The index maps to samples per microsecond: 100, 50 and 25. */
export enum DigitizerSamplingRate {
    F100MHz = 0,
    F50MHz = 1,
    F25MHz = 2,
}

export enum UnitOfLength {
    Mm = 0,
    Inch = 1,
}

/** A single UT waveform (A-scan) as stored in measurements.chartDataJson and rendered by the WaveformChart component. */
export interface IWaveFormResult {
    measuredDateTime: string;
    /** Amplitude samples on a 0-2000 scale where 2000 equals 100%. */
    data: number[];
    gate1Amp: number;
    gate1Tof: number;
    gate2Amp: number;
    gate2Tof: number;
    gate3Amp: number;
    gate3Tof: number;
    adGain: number;
    adDelay: number;
    adWidth: number;
    prMode: number;
    prPrf: number;
    prVoltage: number;
    prWidth: number;
    digitizerSamplingRate: number;
    adFilterMode: number;
    adAveraging: number;
    useGate1: boolean;
    gate1Start: number;
    gate1Width: number;
    gate1Threshold: number;
    gate1Mode: number;
    useGate2: boolean;
    gate2Start: number;
    gate2Width: number;
    gate2Threshold: number;
    gate2Mode: number;
    rectify: number;
    isConnected: boolean;
}

/** The parsed shape of measurements.chartDataJson. */
export interface IUtMeasurementChartData {
    waveFormResult: IWaveFormResult;
    velocity?: number;
    unitOfLength?: UnitOfLength;
}
